import { getIsMobile, getIsDesktop } from '../../utils/ua'

const visibility = state => state.visibility

export const coverShareButtonsInView = state => !visibility(state).coverShareButtonsInView

export const shouldShowNavigationInMobile = state =>
  ((visibility(state).isScrollUp || !visibility(state).titleIsAboveViewport) && getIsMobile()) ||
  getIsDesktop()



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/visibility/visibility.selectors.js